import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Assets from 'imports/assets.import';
import MaskIcon from '../mask_icon/mask_icon.ui';
import { ADMIN_NAV_ITEMS } from 'utils/constant.utils';
import { getAdminNavKey } from 'utils/functions.utils';
import './admin_sidebar.ui.scss';

const NAV_ICONS: Record<string, string> = {
  overview: Assets.admin_nav_overview,
  users: Assets.admin_nav_users,
  projects: Assets.admin_nav_projects,
  tickets: Assets.admin_nav_tickets,
};

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeKey = getAdminNavKey(location.pathname);

  return (
    <nav className="admin_sidebar" aria-label="Admin sections">
      <div className="admin_sidebar_brand">Augmo Admin</div>
      {ADMIN_NAV_ITEMS.map((item) => (
        <button
          key={item.key}
          type="button"
          className={`admin_sidebar_item${activeKey === item.key ? ' admin_sidebar_item--active' : ''}`}
          aria-current={activeKey === item.key ? 'page' : undefined}
          onClick={() => navigate(item.route)}>
          <MaskIcon src={NAV_ICONS[item.key]} />
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default AdminSidebar;
